import store from '../../store';
import Errors from '../../Errors';
import CartHelpersMixin from '../../mixins/CartHelpersMixin';
import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';

export default {
    mixins: [
        CartHelpersMixin,
        ProductHelpersMixin,
    ],

    props: ['customerEmail', 'customerPhone', 'gateways', 'defaultAddress', 'billingAddress', 'shippingAddress', 'countries'],

    data() {
        return {
            form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {},
                shipping: {},
                billingAddressId: null,
                shippingAddressId: null,
                newBillingAddress: false,
                newShippingAddress: false,
                shippingRules: null,
                wantInvoice: false
            },
            states: {
                billing: {},
                shipping: {},
            },
            placingOrder: false,
            errors: new Errors(),
            stripe: null,
            stripeCardElement: null,
            stripeError: null,
        };
    },

    computed: {
        hasBillingAddress() {
            return this.billingAddress && Object.keys(this.billingAddress).length !== 0;
        },

        hasShippingAddress() {
            return this.shippingAddress && Object.keys(this.shippingAddress).length !== 0;
        },

        firstCountry() {
            return Object.keys(this.countries)[0];
        },

        hasBillingStates() {
            return Object.keys(this.states.billing).length !== 0;
        },

        hasShippingStates() {
            return Object.keys(this.states.shipping).length !== 0;
        },

        hasNoPaymentMethod() {
            return Object.keys(this.gateways).length === 0;
        },

        firstPaymentMethod() {
            return Object.keys(this.gateways)[0];
        },

        shouldShowPaymentInstructions() {
            return ['bank_transfer', 'check_payment'].includes(this.form.payment_method);
        },

        paymentInstructions() {
            if (this.shouldShowPaymentInstructions) {
                return this.gateways[this.form.payment_method].instructions;
            }
        },
    },

    watch: {
        'form.billingAddressId': function(value) {

            if (value != null)
                this.form.newBillingAddress = false;
            this.mergeSavedAddresses();
            if (this.form.shipping_method)
                this.updateShippingMethod(this.form.shipping_method, store.state.shipping);
        },

        'form.shippingAddressId': function(value) {

            if (value != null)
                this.form.newShippingAddress = false;
            this.mergeSavedAddresses();

            if (this.form.shipping_method)
                this.updateShippingMethod(this.form.shipping_method, store.state.shipping);
        },

        'form.newBillingAddress': function(newValue) {
            // if (!this.form.ship_to_a_different_address)
            //     this.form.shipping_method = null;

            if (newValue)
                this.form.billingAddressId = null;
        },

        'form.newShippingAddress': function(newValue) {
            // if (this.form.ship_to_a_different_address)
            //     this.form.shipping_method = null;

            if (newValue)
                this.form.shippingAddressId = null;
        },

        // 'form.billing.city': function(newCity) {
        //     if (newCity) {
        //         this.addTaxes();
        //     }
        // },

        // 'form.delivery_type': function(newHomeDelivery) {
        //     console.log(newHomeDelivery);
        // },

        // 'form.shipping.city': function(newCity) {
        //     if (newCity) {
        //         this.addTaxes();
        //     }
        // },

        // 'form.shipping.country': function(newCountry) {
        //     if (newCountry) {
        //         store.updateShipping(this.form.shipping)
        //         this.addTaxes();
        //         this.updateShippingMethod(this.form.shipping_method, store.state.shipping);
        //     }

        // },

        // 'form.billing.zip': function(newZip) {
        //     if (newZip) {
        //         this.addTaxes();
        //     }
        // },

        // 'form.shipping.zip': function(newZip) {
        //     if (newZip) {
        //         this.addTaxes();
        //     }
        // },

        // 'form.billing.state': function(newState) {
        //     if (newState) {
        //         this.addTaxes();
        //     }
        // },

        // 'form.shipping.state': function(newState) {
        //     if (newState) {
        //         this.addTaxes();
        //     }
        // },

        'form.ship_to_a_different_address': function(newValue) {

            this.mergeSavedAddresses();
            if (newValue) {

                store.updateShipping(this.form.shipping)
                if (this.form.shipping_method)
                    this.updateShippingMethod(this.form.shipping_method, store.state.shipping);
            } else {
                store.updateShipping(this.form.billing)
                if (this.form.shipping_method)
                    this.updateShippingMethod(this.form.shipping_method, store.state.shipping);
            }
        },

        'form.terms_and_conditions': function() {
            this.errors.clear('terms_and_conditions');
        },

        'form.payment_method': function(newPaymentMethod) {
            if (newPaymentMethod === 'paypal' || newPaymentMethod === 'paypal-card') {
                this.$nextTick(this.renderPayPalButton);
            }

            if (newPaymentMethod !== 'stripe') {
                this.stripeError = '';
            }
        },
    },


    created() {
        if (this.defaultAddress.address_id) {
            // this.form.billingAddressId = this.defaultAddress.address_id;
            // this.form.shippingAddressId = this.defaultAddress.address_id;
        }
        // store.updateShipping(this.form.shipping)


        if (!this.hasBillingAddress) {
            this.form.newBillingAddress = true;
            this.changeBillingCountry(this.firstCountry);

        }

        if (!this.hasShippingAddress) {
            this.form.newShippingAddress = true;
            this.changeShippingCountry(this.firstCountry, false);
        }



        this.$nextTick(() => {
            if (this.firstPaymentMethod) {
                this.changePaymentMethod(this.firstPaymentMethod);
            }

            if (this.firstShippingMethod) {
                // this.updateShippingMethod(this.firstShippingMethod, store.state.shipping);
            }

            if (window.Stripe) {
                this.stripe = window.Stripe(FleetCart.stripePublishableKey);

                this.renderStripeElements();
            }
        });
    },

    methods: {
        addNewBillingAddress() {
            this.errors.reset();

            this.form.billing = {};
            this.form.newBillingAddress = !this.form.newBillingAddress;
        },

        addNewShippingAddress() {
            this.errors.reset();

            this.form.shipping = {};
            this.form.newShippingAddress = !this.form.newShippingAddress;
        },

        mergeSavedAddresses() {

            if (!this.form.newBillingAddress && this.form.billingAddressId) {
                this.form.billing = this.billingAddress[this.form.billingAddressId];
                store.updateShipping(this.form.billing)
            }

            if (
                this.form.ship_to_a_different_address &&
                !this.form.newShippingAddress &&
                this.form.shippingAddressId
            ) {
                this.form.shipping = this.shippingAddress[this.form.shippingAddressId];
                store.updateShipping(this.form.shipping)
            }
        },

        changeBillingCity(city) {
            this.$set(this.form.billing, 'city', city);
        },

        changeShippingCity(city) {
            this.$set(this.form.shipping, 'city', city);
        },

        changeBillingZip(zip) {
            this.$set(this.form.billing, 'zip', zip);
        },

        changeShippingZip(zip) {
            this.$set(this.form.shipping, 'zip', zip);
        },

        changeBillingCountry(country) {
            this.$set(this.form.billing, 'country', country);

            store.updateShipping(this.form.billing);

            if (!this.form.ship_to_a_different_address && this.form.shipping_method) {

                this.updateShippingMethod(this.form.shipping_method, store.state.shipping);
            }

            // this.updateShippingMethod(this.firstShippingMethod, store.state.shipping);
            this.fetchStates(country, (states) => {
                this.$set(this.states, 'billing', states);
                this.$set(this.form.billing, 'state', '');
            });
        },

        changeShippingCountry(country, fire = true) {
            this.$set(this.form.shipping, 'country', country);
            store.updateShipping(this.form.shipping)
            if (this.form.ship_to_a_different_address && this.form.shipping_method) {

                this.updateShippingMethod(this.form.shipping_method, store.state.shipping);
            }
            this.fetchStates(country, (states) => {
                this.$set(this.states, 'shipping', states);
                this.$set(this.form.shipping, 'state', '');
            });
        },

        changeHomeDeliveryType(value) {
            this.loadingOrderSummary = true;

            $.ajax({
                method: 'POST',
                url: route('cart.shipping_method.store', {
                    shipping_method: this.form.shipping_method
                }),
                data: {
                    form_shipping: store.state.shipping,
                    shipping_charge: value
                }
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        fetchStates(country, callback) {
            $.ajax({
                method: 'GET',
                url: route('countries.states.index', { code: country }),
            }).then(callback);
        },

        changeBillingState(state) {
            this.$set(this.form.billing, 'state', state);
        },

        changeShippingState(state) {
            this.$set(this.form.shipping, 'state', state);
        },

        changePaymentMethod(paymentMethod) {
            this.$set(this.form, 'payment_method', paymentMethod);
        },

        changeShippingMethod(shippingMethod) {
            this.$set(this.form, 'shipping_method', shippingMethod.name);
        },

        addTaxes() {
            this.loadingOrderSummary = true;

            $.ajax({
                method: 'POST',
                url: route('cart.taxes.store'),
                data: this.form,
            }).then((cart) => {
                // console.log(cart);
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        placeOrder() {
            window.store = store;
            if (!this.form.terms_and_conditions || this.placingOrder) {
                return;
            }

            this.placingOrder = true;

            $.ajax({
                method: 'POST',
                url: route('checkout.store'),
                data: this.form,
            }).then((response) => {
                if (response.redirectUrl || response.checkoutUrl) {
                    if (response.redirectUrl)
                        window.location.href = response.redirectUrl;
                    else
                        window.location.href = response.checkoutUrl;
                } else if (this.form.payment_method === 'stripe') {
                    this.confirmStripePayment(response);
                } else if (this.form.payment_method === 'paytm') {
                    this.confirmPaytmPayment(response);
                } else if (this.form.payment_method === 'razorpay') {
                    this.confirmRazorpayPayment(response);
                } else {
                    this.confirmOrder(response.orderId, this.form.payment_method);
                }
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                }

                this.$notify(xhr.responseJSON.message);

                this.placingOrder = false;
            });
        },

        confirmOrder(orderId, paymentMethod, params = {}) {
            $.ajax({
                method: 'GET',
                url: route('checkout.complete.store', { orderId, paymentMethod, ...params }),
            }).then(() => {
                window.location.href = route('checkout.complete.show');
            }).catch((xhr) => {
                this.placingOrder = false;
                this.loadingOrderSummary = false;

                this.deleteOrder(orderId);
                this.$notify(xhr.responseJSON.message);
            });
        },

        deleteOrder(orderId) {
            if (!orderId) {
                return;
            }

            $.ajax({
                method: 'GET',
                url: route('checkout.payment_canceled.store', { orderId }),
            });
        },

        renderPayPalButton() {
            let vm = this;
            let response;

            window.paypal.Buttons({
                async createOrder() {
                    try {

                        response = await $.ajax({
                            method: 'POST',
                            url: route('checkout.store'),
                            data: {
                                ...vm.form,
                                type: 'buttons',
                            },
                        });

                        return response.resourceId;
                    } catch (xhr) {
                        if (xhr.status === 422) {
                            vm.errors.record(xhr.responseJSON.errors);
                        } else {
                            vm.$notify(xhr.responseJSON.message);
                        }
                    }
                },
                onApprove() {
                    vm.loadingOrderSummary = true;

                    vm.confirmOrder(response.orderId, 'paypal', {...response, type: 'buttons'});
                },
                onError() {
                    vm.deleteOrder(response.orderId);
                },
                onCancel() {
                    vm.deleteOrder(response.orderId);
                },
            }).render('#paypal-button-container');

            if (window.paypal.HostedFields.isEligible()) {
                let orderId, resourceId;
                let hasErrors = false;

                // Renders card fields
                window.paypal.HostedFields.render({
                    // Call your server to set up the transaction
                    createOrder: async () => {
                        // console.log('hosted fields, createOrder');
                        hasErrors = false;
                        this.loadingOrderSummary = true;

                        try {
                            response = await $.ajax({
                                method: 'POST',
                                url: route('checkout.store'),
                                data: {
                                    ...vm.form,
                                    payment_method: 'paypal',
                                    type: 'credit-cards',
                                },
                            })

                            orderId = response.orderId;
                            resourceId = response.resourceId;
                            return response.resourceId;
                        } catch (xhr) {
                            hasErrors = true;
                            if (xhr.status === 422) {
                                vm.errors.record(xhr.responseJSON.errors);
                            } else {
                                vm.$notify(xhr.responseJSON.message);
                            }
                        }
                    },
                    styles: {
                        '.valid': {
                            color: 'green',
                        },
                        '.invalid': {
                            color: 'red',
                        },
                    },
                    fields: {
                        number: {
                            selector: "#card-number",
                            placeholder: "4111 1111 1111 1111",
                        },
                        cvv: {
                            selector: "#cvv",
                            placeholder: "123",
                        },
                        expirationDate: {
                            selector: "#expiration-date",
                            placeholder: "MM/YY",
                        }
                    }
                }).then((cardFields) => {
                    document.querySelector("#submit").addEventListener("click", (event) => {
                        event.preventDefault();
                        cardFields
                            .submit({

                                // Triggering the 3D Secure
                                contingencies: ['SCA_ALWAYS'],

                                // Cardholder's first and last name
                                cardholderName: document.getElementById("card-holder-name").value,
                                // Billing Address
                                billingAddress: {
                                    // Street address, line 1
                                    streetAddress: document.querySelector('[name="billing[address_1]"]').value,
                                    // Street address, line 2 (Ex: Unit, Apartment, etc.)
                                    extendedAddress: document.querySelector('[name="billing[address_2]"]').value,
                                    // State
                                    region: document.querySelector('[name="billing[state]"]').value,
                                    // City
                                    locality: document.querySelector('[name="billing[city]"]').value,
                                    // Postal Code
                                    postalCode: document.querySelector('[name="billing[zip]"]').value,
                                    // Country Code
                                    countryCodeAlpha2: document.querySelector('[name="billing[country]"]').value,
                                },
                            })
                            .then(async () => {
                                // 3D Secure check and Capture

                                $.ajax({
                                    method: 'GET',
                                    url: route('checkout.complete.store', {
                                        orderId,
                                        resourceId,
                                        paymentMethod: 'paypal',
                                        type: 'credit-cards',
                                        ...vm.form
                                    }),
                                }).then((data) => {
                                    window.location.href = route('checkout.complete.show');
                                }).catch((xhr) => {
                                    this.placingOrder = false;
                                    this.loadingOrderSummary = false;

                                    this.deleteOrder(orderId);
                                    let errorMessage = '';

                                    // data.result is one of the following values returned from the backend:
                                    // "unknown", "retry", "genericIssue", otherwise is the API Response
                                    let result = xhr.responseJSON.message;

                                    let retry = "3d Secure Failed (Request cardholder to retry): <br><br>An error occurred during the transaction. Please try again.";
                                    let unknownError = "3d Secure Failed (Do not continue with authorization):<br><br>An unknown error occurred during the transaction. Please consult your credit card issuer.";
                                    let genericIssue = "An issue to identify prevented the capture of the payment.";

                                    // Do not continue with authorization.
                                    if (result === "paypal-unknown") {
                                        errorMessage = unknownError;
                                    }
                                    // Do not continue with authorization. Request cardholder to retry.
                                    else if (result === "paypal-retry") {
                                        errorMessage = retry;
                                    }
                                    // An issue to identify prevented the capture of the payment.
                                    else if (result === "paypal-genericIssue") {
                                        errorMessage = genericIssue;
                                    } else {
                                        errorMessage = 'Error';
                                    }

                                    this.$notify(errorMessage);
                                });
                            })
                            // If any error:
                            .catch((err) => {
                                if (hasErrors) {
                                    this.loadingOrderSummary = false;
                                    return;
                                }
                                this.$notify("Payment could not be captured! " + JSON.stringify(err));
                            });
                    });
                });
            } else {
                // Hides card fields if the merchant isn't eligible for receiving CC payments
                document.querySelector("#card-form").style = 'display: none';
            }
        },

        renderStripeElements() {
            this.stripeCardElement = this.stripe.elements().create('card', {
                hidePostalCode: true,
            });

            this.stripeCardElement.mount('#stripe-card-element');
        },

        async confirmStripePayment({ orderId, clientSecret }) {
            let result = await this.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: this.stripeCardElement,
                    billing_details: {
                        email: this.form.customer_email,
                        name: `${this.form.billing.first_name} ${this.form.billing.last_name}`,
                        address: {
                            city: this.form.billing.city,
                            country: this.form.billing.country,
                            line1: this.form.billing.address_1,
                            line2: this.form.billing.address_2,
                            postal_code: this.form.billing.zip,
                            state: this.form.billing.state,
                        },
                    },
                },
            });

            if (result.error) {
                this.placingOrder = false;
                this.stripeError = result.error.message;

                this.deleteOrder(orderId);
            } else {
                this.confirmOrder(orderId, 'stripe', result);
            }
        },

        confirmPaytmPayment({ orderId, amount, txnToken }) {
            let config = {
                root: '',
                flow: 'DEFAULT',
                data: {
                    orderId: orderId,
                    token: txnToken,
                    tokenType: 'TXN_TOKEN',
                    amount: amount,
                },
                merchant: {
                    redirect: false,
                },
                handler: {
                    transactionStatus: (response) => {
                        if (response.STATUS === 'TXN_SUCCESS') {
                            this.confirmOrder(orderId, 'paytm', response);
                        } else if (response.STATUS === 'TXN_FAILURE') {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }

                        window.Paytm.CheckoutJS.close();
                    },
                    notifyMerchant: (eventName) => {
                        if (eventName === 'APP_CLOSED') {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }
                    },
                },
            };

            window.Paytm.CheckoutJS.init(config).then(() => {
                window.Paytm.CheckoutJS.invoke();
            }).catch(() => {
                this.deleteOrder(orderId);
            });
        },

        confirmRazorpayPayment(razorpayOrder) {
            this.placingOrder = false;

            let vm = this;

            new window.Razorpay({
                key: FleetCart.razorpayKeyId,
                name: FleetCart.storeName,
                description: `Payment for order #${razorpayOrder.receipt}`,
                image: FleetCart.storeLogo,
                order_id: razorpayOrder.id,
                handler(response) {
                    vm.placingOrder = true;

                    vm.confirmOrder(razorpayOrder.receipt, 'razorpay', response);
                },
                modal: {
                    ondismiss() {
                        vm.deleteOrder(razorpayOrder.receipt.receipt);
                    },
                },
                prefill: {
                    name: `${vm.form.billing.first_name} ${vm.form.billing.last_name}`,
                    email: vm.form.customer_email,
                    contact: vm.form.customer_phone,
                },
            }).open();
        },
    },
};
